import basketIcon from "./icons/basket-icon.svg";
import editProfileIcon from "./icons/edit-profile-icon.svg";
import hornIcon from "./icons/horn-icon.svg";
import leafIcon from "./icons/leaf-icon.svg";
import throphyIcon from "./icons/throphy-icon.svg";
import goldTrophyIcon from "./icons/trophy.svg";

import rewardsIcon from "./icons/rewards-icon.svg";

import whiteLabelTrophyIcon from "./icons/white-label-trophy-icon.svg";
import emblem from "./img/emblem.png";
import homeBackgroundImage from "./img/home-bg.jpg";

const icons = {
  throphyIcon,
  leafIcon,
  editProfileIcon,
  basketIcon,
  hornIcon,
  goldTrophyIcon,
  whiteLabelTrophyIcon,

  rewardsIcon
};

const images = {
  emblem,
  homeBackgroundImage,
  ...icons
};

export default images;



// WEBPACK FOOTER //
// ./src/assets/index.ts